<script setup lang="ts">
import { computed } from 'vue'
import Kbd from '@/components/shadcn/Kbd.vue'

type StyleType =
  | 'default'   // 기본 스타일
  | 'primary'   // 강조 스타일 (파랑)
  | 'success'   // 성공 스타일 (초록)
  | 'warning'   // 경고 스타일 (주황)
  | 'danger'    // 위험 스타일 (빨강)

type SizeType = 'xs' | 'sm' | 'md' | 'lg'

const props = withDefaults(
  defineProps<{
    class?: string
    /** 스타일 프리셋 */
    styletype?: StyleType
    /** 키보드 키 크기 */
    size?: SizeType
  }>(),
  {
    styletype: 'default',
    size: 'sm',
  },
)

/**
 * styletype -> class 매핑
 */
const STYLE_PRESETS: Record<StyleType, { class: string }> = {
  default: { class: '' },
  primary: { 
    class: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  success: { 
    class: 'bg-green-100 text-green-800 border-green-200',
  },
  warning: { 
    class: 'bg-amber-100 text-amber-800 border-amber-200',
  },
  danger: { 
    class: 'bg-red-100 text-red-800 border-red-200',
  },
}

/**
 * size -> class 매핑
 */
const SIZE_PRESETS: Record<SizeType, { class: string }> = {
  xs: { 
    class: 'h-3.5 px-0.5 text-[10px] min-w-[14px]',
  },
  sm: { 
    class: 'h-4 px-1 text-xs min-w-[16px]',
  },
  md: { 
    class: 'h-5 px-1.5 text-xs',
  },
  lg: { 
    class: 'h-6 px-2 text-sm',
  },
}

/** 최종 바인딩: styletype과 size를 병합하여 최종 클래스 생성 */
const mapped = computed(() => {
  const stylePreset = STYLE_PRESETS[props.styletype!]
  const sizePreset = SIZE_PRESETS[props.size!]
  const finalClass = [stylePreset.class, sizePreset.class, props.class].filter(Boolean).join(' ')
  
  return {
    class: finalClass,
  }
})
</script>

<template>
  <Kbd v-bind="mapped">
    <slot />
  </Kbd>
</template>
